<button
    type="button"
    class="status-message-trigger"
    [matMenuTriggerFor]="toastCount() > 0 ? statusMessagesPanel : null"
    [class.message-icon]="toastCount() > 0"
    [class.message-icon-disabled]="toastCount() === 0"
    [matBadgeDisabled]="toastCount() === 0"
    [matBadgeHidden]="toastCount() === 0"
    [matBadge]="toastCount() === 0 ? '' : (toastCount() <= 99 ? toastCount() : '99+')"
    [aria-label]="(statusMessagesLabels | contentFilter: LABELS.OPEN_STATUS_MESSAGES) || 'Open status messages'"
    (click)="toastCount() > 0 ? openStatusMessagePanel() : ''"
>
    <srp-icon icon="message" aria-hidden="false"></srp-icon>
</button>

@if (isToastShown()) {
<div class="srp-notification-container container">
    @for ( toast of visibleTopToasts; track toast.id) {
        <div class="srp-notification-wrapper" [class.srp-notification-wrapper-stacked]="$last && stackedTopToastsCount > 0">
            <div [class]="isAlertToast(toast) ? 'srp-notification-warning' : 'srp-notification-info'">
            <div class="toast-leading-icon">
                <srp-icon [icon]="toast.iconPath" class="type-icon" [variant]="'symbols-outlined'"></srp-icon>
            </div>
            <div class="content">
                <span class="toast_msg_date">{{ toast.startDateTimeInUTC | date: 'fullDate'}}</span>
                <span class="toast_msg" [innerHTML]="toast.shortDescription"></span>
                <a [href]="toast.link" (click)="$event.preventDefault(); navigate(toast.link, toast.linkAuthField, toast.linkType)" class="toast_msg_link">{{ toast.linkLabel}}</a>
            </div>
            <button type="button" class="close-icon" aria-label="Dismiss message" (click)="markStatusMessageAsNotified(toast)">
                <srp-icon [icon]="'close'" [variant]="'symbols-outlined'"></srp-icon>
            </button>
        </div>
            @if ($last && stackedTopToastsCount > 0) {
                                <div class="srp-notification-stack-behind" aria-hidden="true">
                                        @for (stackToast of stackedAnchorToasts; track stackToast.id; let stackIndex = $index) {
                                                <div
                                                    class="srp-notification-stack-card"
                                                    [class.srp-notification-stack-card-1]="stackIndex === 0"
                                                    [class.srp-notification-stack-card-2]="stackIndex === 1"
                                                    [class.srp-notification-stack-card-3]="stackIndex === 2"
                                                    [class.srp-notification-stack-warning]="isAlertToast(stackToast)"
                                                    [class.srp-notification-stack-info]="!isAlertToast(stackToast)"
                                                ></div>
                                        }
                </div>
            }
        </div>
    }
</div>
}

<mat-menu #statusMessagesPanel="matMenu" (click)="$event.stopImmediatePropagation()" (keydown)="$event.stopImmediatePropagation()" class="status-messages-panel" overlayPanelClass="status-messages-overlay-pane" [overlapTrigger]="false" xPosition="before">
    <div class="status-messages-menu" (click)="$event.stopImmediatePropagation()" (keydown)="$event.stopImmediatePropagation()">
        <div class="status-messages-header">
            <h2 class="status-messages-header-text">{{(statusMessagesLabels | contentFilter: LABELS.SERVICE_MESSAGES) || 'Service Messages'}}</h2>
            <button type="button" class="status-messages-header-icon" aria-label="Close panel" (click)="closeStatusMessagePanel()">
                <srp-icon icon="close"></srp-icon>
            </button>
        </div>
        <div class="status-messages-snackbar-wrapper">
        <div class="status-message-snackbar">
            <srp-icon class="status-message-snackbar-icon" icon="info" variant="filled"></srp-icon>
            <span class="status-message-snackbar-text">{{ (statusMessagesLabels | contentFilter: LABELS.YOU_HAVE) || 'You have'}} {{toastCount()}} {{(statusMessagesLabels | contentFilter: LABELS.UNREAD_MESSAGES) || 'unread messages.'}}</span>
        </div>
        </div>
        <div class="status-message-content-div">
            <div class="status-message-div">
                @for(message of panelToasts(); track $index) {
                    <article class="status-message">
                        <div class="status-message-heading">
                            <div class="status-message-heading-title">
                                <span class="status-message-heading-title-text">{{ message.title }}</span>
                                @if(message.category) {
                                    <span class="status-message-heading-title-type">{{ message.category | titlecase }}</span>
                                }
                            </div>
                            <span class="status-message-heading-timestamp">{{ getTimeForPanel(message.startDateTimeInUTC) }}</span>
                        </div>
                        <span class="status-message-description" [innerHTML]="message.shortDescription"></span>
                        <a [href]="serviceMessagesRoute" class="status-message-link" (click)="$event.preventDefault(); 
                        matMenuTrigger.closeMenu();  
                        redirectToServiceMessagesCenter()"
                        >{{ message.linkLabel }}</a>
                    </article>
                }
            </div>
            <div class="status-messages-footer">
                <srp-button class="status-messages-footer-button" (click)="redirectToServiceMessagesCenter()" (keydown)="redirectToServiceMessagesCenter()">{{(statusMessagesLabels | contentFilter: LABELS.VIEW_ALL_MESSAGES) || 'VIEW ALL MESSAGES'}}</srp-button>
            </div>
        </div>
    </div>
</mat-menu>
